export const currentVersion = "1.1.20240"; // <-- value is replaced by CI build (see .github/workflows/backoffice.yml)
